/*
 * Created Date: Mon, 26th Jul 2021, 17:45:29 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2021 The Distance
 */

import React from 'react';
import { Create } from 'react-admin';
import AdminForm from './form';

const AdminCreate = (props) => {
  const { resource } = props;

  return (
    <Create title={`resources.${resource}.titles.create`} {...props}>
      <AdminForm />
    </Create>
  );
};

export default AdminCreate;
